module.exports = __webpack_public_path__ + "assets/img/zbcgbg1.41b62183.png";